import * as React from 'react';
import { useState } from 'react';
import { format, addDays } from 'date-fns';

import t from './locales';
import Button from '../Shared/Button';
import { IPriceTable } from './types';
import { CURRENT_CART_VERSION, DATE_FORMAT } from './constants';
import { ICartItems, IOrderItem, IPeople, IResort } from './types';
import { retrieveCartItems, storeCartItems } from './helpers';

// Fake API integration for new.
const syncCart = () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, 1000);
  });
};

interface IProps {
  itemId: number;
  itemName: string;
  people: IPeople;
  payableDateList: Date[];
  dateDuration: number;
  priceTable: IPriceTable;
  resort?: IResort;
  maxParticipants?: number;
  timeSchedule?: string;
  validate: () => boolean;
  isKanjiwari?: boolean;
  deposit: number;
  numberOfVouchers?: number;
  charge: boolean;
  axess: boolean;
}

const SnowItemCartButton: React.FC<IProps> = (props) => {
  const { itemId, itemName, people, payableDateList, dateDuration, priceTable, resort, maxParticipants, timeSchedule, validate, isKanjiwari, deposit, charge: isCharge, axess } = props;
  const [isLoading, toggleLoading] = useState(false);
  const url = new URL(window.location.href);

  const handleClick = async (event: React.MouseEvent): Promise<void> => {
    event.preventDefault();
    if (isLoading) { return; }
    if (!validate()) { return; }
    toggleLoading(true);
    const prevCartItems: ICartItems = retrieveCartItems(CURRENT_CART_VERSION);
    let orderItems: IOrderItem[] = prevCartItems.orderItems || [];

    orderItems = (prevCartItems.orderItems || []).concat(
      payableDateList.map((date) => {
        const checkInDate = format(date, DATE_FORMAT);
        const checkOutDate = format(addDays(date, dateDuration - 1), DATE_FORMAT);
        const price = priceTable[checkInDate];
        return { itemId, itemName, people, checkInDate, checkOutDate, price, maxParticipants, resort, timeSchedule, isKanjiwari, type: "Order", deposit, isCharge };
      })
    );
    const cartItems = { ...prevCartItems, orderItems };
    await syncCart();
    storeCartItems(cartItems);
    toggleLoading(false);
    // 複数日選択の場合は先頭のみトラッキング
  };

  return (
    // snow-cart-button = gtmのカートインイベント用のクラス
    // TODO: クラス以外の方法でトリガーする
    <Button href="#" onClick={handleClick} isLoading={isLoading} snowItemButton={true} className="snow-cart-button">
      {t.addToCart()}
    </Button>
  );
}

export default SnowItemCartButton;
